<picture>
  <!-- <source [srcset]="src | imageSize: size:250" type="image/webp" width="100%" height="100%" /> -->
  <img [src]="src | imageSize: size:'webp'" width="100%" height="100%" loading="lazy" (load)="handleImageLoad($event)" />
</picture>
